import { render } from "./App.vue?vue&type=template&id=03ed3057"
const script = {}

import "./App.vue?vue&type=style&index=0&id=03ed3057&lang=css"
script.render = render

export default script